import { isNum, isStr, curryN } from '@exah/utils';
/**
 * Convert number to rem
 *
 * @example
 * import { rem } form 'pss'
 *
 * rem() // → 1rem
 * rem(16) // → 1rem
 * rem(20) // → 1.25rem
 * rem('20px') // → 1.25rem
 * rem(20, 20) // → 1rem
 */

export var rem = function rem(input, base) {
  if (input === void 0) {
    input = 16;
  }

  if (base === void 0) {
    base = 16;
  }

  return /rem$/.test(input) ? input : parseFloat(input, 10) / base + "rem";
};
/**
 * Convert numbers to pixels
 *
 * @example
 * import { px } from 'pss'
 *
 * px(30) // → '30px'
 * px(0) // → 0
 * px('100px') // → '100px'
 * px('100rem') // → '100rem' (nothing changed)
 */

export var px = function px(num) {
  return isNum(num) && num !== 0 ? num + "px" : num;
};
export var cap = function cap(input) {
  if (input === void 0) {
    input = '';
  }

  return input.replace(/^\w/, function (c) {
    return c.toUpperCase();
  });
};
export var addPrefix = function addPrefix(input, prefix) {
  if (input === void 0) {
    input = '';
  }

  return prefix ? prefix + cap(input) : input;
};
export var wrap = curryN(2, function (name, value) {
  var _ref;

  return value != null ? name ? (_ref = {}, _ref[name] = value, _ref) : value : null;
});
export var wrapIfMedia = function wrapIfMedia(query, style) {
  return wrap(query ? "@media " + query : null, style);
};

var parseUnit = function parseUnit(str) {
  return str.replace(/([\d.]+)(\D+)?$/, '$2').trim() || undefined;
};
/**
 * @example
 * import { splitUnit } from 'pss'
 *
 * const [ value, unit ] = splitUnit('30px') // → [ 30, 'px' ]
 */


export var splitUnit = function splitUnit(input) {
  return isStr(input) ? [parseFloat(input, 10), parseUnit(input)] : isNum(input) ? [input, undefined] : [];
};
export var floor = function floor(number, precision) {
  if (precision === void 0) {
    precision = 0;
  }

  var factor = Math.pow(10, precision);
  return Math.floor(number * factor) / factor;
};